import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="text-xs text-foreground-500">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((c, i) => (
          <li key={c.label} className="flex items-center gap-1.5">
            {c.to ? (
              <Link to={c.to} className="transition hover:text-primary-600">
                {c.label}
              </Link>
            ) : (
              <span aria-current="page" className="font-medium text-foreground-800">
                {c.label}
              </span>
            )}
            {i < items.length - 1 && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
          </li>
        ))}
      </ol>
    </nav>
  );
}